import { useCallback, useState } from 'react';
import { FormFields } from '@/components/ContactUs/ContactUsFormSection';
import { httpService, useNotification } from '@visalex/core';

import { useTranslation } from 'next-i18next';

import { ActivityType } from './types';

export const handleFormSubmit = () => {
  const { t, i18n } = useTranslation();
  const { addNotification } = useNotification();
  const [isSubmitWithError, setSubmitWithError] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (formData: FormFields) => {
      setLoading(true);

      const activityModel = {
        ...formData,
        reason: formData.reason?.value,
        nationality: formData.nationality?.value,
        language: formData.language?.value,
        type: ActivityType.CONSULTATION_REQUESTED,
      };

      await httpService
        .post(
          'api/contact',
          { ...activityModel, currentPageLang: i18n.language },
          { baseUrl: '/', showErrorNotification: false }
        )
        .then(() => {
          setSubmitWithError(false);
        })
        .catch(() => {
          addNotification({
            title: t('common.error-notification.title'),
            description: t('common.error-notification.description'),
          });
          setSubmitWithError(true);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [addNotification]
  );

  return { handleSubmit, isSubmitWithError, isLoading };
};
